<template>
  <Card class="LicenseDisplay">
    <section>
      <Heading
        type="tertiary"
        level="2"
        :heading="messages.licenseDisplay.numberOfLicense"
      />
      <ul class="LicenseDisplay__list">
        <li
          v-for="license in licenseList"
          :key="license.key"
          class="LicenseDisplay__item"
          @click="navigateToLicense(license.key)"
        >
          <span class="LicenseDisplay__text">{{
            getLicenseName(license.key)
          }}</span>
          <div class="LicenseDisplay__inner">
            <LicenseGraf
              class="LicenseDisplay__licenseGraf"
              :percentage="percentage(license.usedQuantity, license.quantity)"
            />
            <span class="LicenseDisplay__subText">
              ({{ license.usedQuantity ? license.usedQuantity : 0 }}/{{
                license.quantity
              }})
            </span>
          </div>
        </li>
      </ul>
    </section>
  </Card>
</template>

<script lang="ts">
export default {
  name: 'LicenseDisplay',
};
</script>

<script lang="ts" setup>
import Card from '@spectee/components/Atoms/Card/index.vue';
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import LicenseGraf from '@spectee/components/Atoms/LicenseGraf/index.vue';
import { LicenseValue } from '@spectee/graphql/api';
import { serviceLicenseSettingData } from '@spectee/resources/serviceLicenseSetting.ts';
import { useRouter } from 'vue-router';
import messages from '../../../messages.json';

const router = useRouter();

type Props = {
  serviceId: string;
  licenseList: LicenseValue[];
};

const props = defineProps<Props>();

const getLicenseName = key => {
  return serviceLicenseSettingData
    .find(service => service.serviceId === props.serviceId)
    ?.licenses.find(license => license.key === key)?.name;
};

const percentage = (usedQuantity, totalQuantity) => {
  return (usedQuantity / totalQuantity) * 100;
};

const navigateToLicense = (licenseId: string) => {
  if (!props.serviceId) return;

  router.push({
    name: 'AdminContractLicense',
    params: {
      licenseId,
      planMasterId: props.serviceId,
    },
  });
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.LicenseDisplay {
  padding: $service-unit * 4 $service-unit * 4 $service-unit * 6;

  &__text {
    display: block;
    font-size: $service-font-size-p;
    font-weight: bold;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: $service-unit $service-unit * 3;
  }

  &__item {
    width: calc(50% - $service-unit * 2);
    background-color: #f8f8f8;
    padding: $service-unit * 3;
    margin-top: $service-unit * 2;
    cursor: pointer;
  }

  &__inner {
    display: flex;
    align-items: center;
    margin-top: $service-unit * 3;
  }

  & &__licenseGraf {
    width: $service-unit * 120;
  }

  &__subText {
    margin-left: $service-unit * 5;
    font-size: $service-font-size-p;
  }
}
</style>
